import React from "react";
import { useTheme } from "@mui/material/styles";
import { Typography, Box } from "@mui/material";

import ModalContainer from "components/ModalContainer";
import { SolidButton } from "components/buttons/SolidButton";
import { OutlineButton } from "components/buttons/OutlineButton";

const LeaveConfirmModal = ({
  isOpen,
  onClose,
  leaveCallback,
  profileType = "schedule",
  title
}) => {
  const theme = useTheme();
  const capitalizedType = profileType.charAt(0).toUpperCase() + profileType.slice(1);

  return (
    <ModalContainer display={isOpen} modalWidth="500px">
      <Box sx={{ textAlign: "center" }}>
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontWeight: theme.typography.customFontWeight[3],
            fontSize: theme.typography.customFontSize[5],
          }}
        >
          {title || `Create New ${capitalizedType}`}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.black,
              fontSize: theme.typography.customFontSize[3],
              fontFamily: theme.typography.fontFamily,
              fontWeight: theme.typography.customFontWeight[0],
              whiteSpace: "pre-wrap",
            }}
          >
            Are you sure you want to abandon edit and go to profile settings?
          </Typography>
        </Box>

        <Box
          sx={{
            paddingTop: "20px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <OutlineButton
            onClick={onClose}
            sx={{ marginRight: "20px" }}
            width="100px"
            height="32px"
          >
            Cancel
          </OutlineButton>
          <SolidButton onClick={leaveCallback} width="100px" height="32px">
            Leave Now
          </SolidButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default LeaveConfirmModal;
